import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class SharedEmitterService {

    static updatePhoto = new EventEmitter();
    
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.emitter.service.ts